import {Grid, InputAdornment, TextField, Tooltip} from "@mui/material";
import {Controller} from "react-hook-form";
import {
    ALPHANUMERIC_REG_EXP,
    CURRENCY_REG_EXP,
    INTEGER_REG_EXP, PROMO_TYPOLOGY_CREDIT_CARD,
    PROMO_TYPOLOGY_SHORT_TERM
} from "../../../component/Constants";
import * as React from "react";
import {checkValueWithInterval} from "../../../component/Utils";
import {useTranslation} from "react-i18next";
import {FormParams} from "../Constants/PromoInterfaces";
import {InfoRounded} from "@mui/icons-material";

const BookingAndDiscountRows = ({watch, control, setValue, isUpdate, updateInitialTypology}: FormParams) => {
    const {t} = useTranslation(['salesmarketing', 'translation']);
    return (
        <>
            <Grid item xs={3}>
                <Controller
                    control={control}
                    name="description"
                    render={({field, fieldState}) => (
                        <TextField
                            fullWidth
                            label={t('promo.description')}
                            value={field.value}
                            onChange={field.onChange}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    )}/>
            </Grid>
            {(watch('typology') === PROMO_TYPOLOGY_SHORT_TERM) &&
                <Grid item xs={3}>
                    <Controller
                        control={control}
                        name="promoCode"
                        render={({field, fieldState}) => (
                            <TextField
                                inputProps={{maxLength: 15}}
                                required
                                disabled={isUpdate && field.value && updateInitialTypology !== PROMO_TYPOLOGY_CREDIT_CARD}
                                fullWidth
                                InputProps={{
                                    endAdornment: <Tooltip arrow
                                                           title={t('promo.createForm.promoCodeLength')}><InfoRounded
                                        color="primary"/></Tooltip>
                                }}
                                label={t('promo.promoCode')}
                                value={field.value}
                                onChange={(e) => {
                                    if (e.target.value === "" || ALPHANUMERIC_REG_EXP.test(e.target.value)) {
                                        setValue!("promoCode", e.target.value)
                                    }
                                }}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                            />
                        )}/>
                </Grid>
            }
            <Grid item xs={3}>
                <Controller
                    control={control}
                    name="discountPercentage"
                    render={({field, fieldState}) => (
                        <TextField
                            disabled={!!watch("discountAmount")}
                            placeholder={watch("discountAmount") ? "--" : ""}
                            fullWidth
                            InputProps={{
                                startAdornment: <InputAdornment position="start">%</InputAdornment>,
                            }}
                            label={t('promo.discountPercentage')}
                            value={field.value}
                            onChange={(e) => {
                                if (e.target.value === "" || INTEGER_REG_EXP.test(e.target.value)) {
                                    setValue!("discountPercentage", checkValueWithInterval(e.target.value, 1, 100));
                                    setValue!("discountAmount", '');
                                }
                            }}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    )}/>
            </Grid>
            <Grid item xs={3}>
                <Controller
                    control={control}
                    name="discountAmount"
                    render={({field, fieldState}) => (
                        <TextField
                            disabled={!!watch("discountPercentage")}
                            placeholder={watch("discountPercentage") ? "--" : ""}
                            fullWidth
                            label={t('promo.discountAmount')}
                            InputLabelProps={{shrink: true}}
                            value={field.value}
                            onChange={(e) => {
                                if (e.target.value === "" || CURRENCY_REG_EXP.test(e.target.value) || e.target.value.startsWith(',') || e.target.value.startsWith('.')) {
                                    setValue!("discountAmount", checkValueWithInterval(e.target.value, 0, 100000));
                                    setValue!("discountPercentage", '');
                                }
                            }}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    )}/>
            </Grid>
            <Grid item xs={3}>
                <Controller
                    control={control}
                    name="maxBookings"
                    render={({field, fieldState}) => (
                        <TextField
                            fullWidth
                            label={t('promo.maxBooking')}
                            type="number"
                            value={field.value}
                            onChange={(e) => {
                                if (INTEGER_REG_EXP.test(e.target.value) || e.target.value === "") {
                                    field.onChange(e);
                                }
                            }}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    )}/>
            </Grid>
            <Grid item xs={3}>
                <Controller
                    control={control}
                    name="maxUserBookings"
                    render={({field, fieldState}) => (
                        <TextField
                            fullWidth
                            label={t('promo.maxBookingsForUser')}
                            type="number"
                            value={field.value}
                            onChange={(e) => {
                                if (INTEGER_REG_EXP.test(e.target.value) || e.target.value === "" ) {
                                    field.onChange(e);
                                }
                            }}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    )}/>
            </Grid>
            <Grid item xs={3}>
                <Controller
                    control={control}
                    name="freeDays"
                    render={({field, fieldState}) => (
                        <TextField
                            fullWidth
                            label={t('promo.freeDays')}
                            type="number"
                            value={field.value}
                            onChange={field.onChange}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    )}/>
            </Grid>
            <Grid item xs={3}>
                <Controller
                    control={control}
                    name="minimumDurationForFreeDays"
                    render={({field, fieldState}) => (
                        <TextField
                            fullWidth
                            label={t('promo.minDurationForFreeDays')}
                            type="number"
                            value={field.value}
                            onChange={field.onChange}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    )}/>
            </Grid>
            <Grid item xs={3}>
                <Controller
                    control={control}
                    name="minimumDuration"
                    render={({field, fieldState}) => (
                        <TextField
                            fullWidth
                            label={t('promo.minDuration')}
                            type="number"
                            value={field.value}
                            onChange={field.onChange}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                        />
                    )}/>
            </Grid>
        </>
    )
}
export default BookingAndDiscountRows;